import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {Event} from '../../../model/Event';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {CancelButtonComponent} from "../../common/cancel-button/cancel-button.component";

@Component({
    selector: 'app-event-bar',
    templateUrl: './event-bar.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        CancelButtonComponent
    ],
    styleUrl: './event-bar.component.scss'
})
export class EventBarComponent {
  @Input('event') event: Event;

  @ViewChild('eventmodal') eventmodal: TemplateRef<any>;

  constructor(private modalService: NgbModal) {
  }

  seeDetail(): void {
    this.modalService.open(this.eventmodal, {size: 'lg', centered: true});
  }
}
